import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {WorkingSureFlowLoop} from '../../model/working-sure-flow-loop';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import {UnitSelectionService} from '../../services/unit-selection-service';
import {SelectionSystemType} from '../../model/selection-system-type';
import {StringUtils} from '../../utils/string-utils';
import {SureFlowScheduleCreationInput} from '../../model/sure-flow-schedule-creation-input';
import {MatButton} from '@angular/material/button';
import {MatCheckbox} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {MatFormField, MatHint, MatLabel} from '@angular/material/form-field';


@Component({
    selector: 'app-add-sure-flow-loops-to-schedule-dialog',
    templateUrl: './add-sure-flow-loops-to-schedule-dialog.component.html',
    styleUrls: ['./add-sure-flow-loops-to-schedule-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, FormsModule, MatHint, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton]
})
export class AddSureFlowLoopsToScheduleDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<AddSureFlowLoopsToScheduleDialogComponent>>(MatDialogRef);
  private readonly unitSelectionService = inject(UnitSelectionService);


  private readonly loops: WorkingSureFlowLoop[];
  systemTypes!: SelectionSystemType[];
  datasource: MatTableDataSource<WorkingSureFlowLoop> = new MatTableDataSource<WorkingSureFlowLoop>();
  selection: SelectionModel<WorkingSureFlowLoop> = new SelectionModel<WorkingSureFlowLoop>(true, []);
  displayColumns: string[] = ['selected', 'description', 'coolingTotalCapacity', 'heatingTotalCapacity'];
  readonly errorMessage = signal<string>(undefined!);
  scheduleInput!: SureFlowScheduleCreationInput;

  constructor() {
    const data = inject(MAT_DIALOG_DATA);

    this.loops = data.loops;
  }

  ngOnInit(): void {
    this.scheduleInput = new SureFlowScheduleCreationInput();
    this.datasource = new MatTableDataSource<WorkingSureFlowLoop>(this.loops);
    this.selection = new SelectionModel<WorkingSureFlowLoop>(true, []);
    this.unitSelectionService.getSureFlowSystemTypes().subscribe({
      next: (systemTypes) => this.systemTypes = systemTypes,
      error: (error) => this.handleError(error)
    });
  }

  private handleError(error: any): void {
    this.errorMessage.set(StringUtils.formatErrorMessage(error));
  }

  canSave(): boolean {
    return StringUtils.isNotBlank(this.scheduleInput?.projectName) && (this.selection.selected?.length || 0) > 0;
  }

  save(): void {
    if (this.canSave()) {
      this.scheduleInput.loops = this.selection.selected;
      this.dialogRef.close(this.scheduleInput);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  masterToggle(): void {
    this.isAllSelected() ?
      this.datasource.data.forEach(row => this.selection.deselect(row)) :
      this.datasource.data.forEach(row => this.selection.select(row));
  }

  isAllSelected(): boolean {
    return (this.selection.selected?.length || 0) === (this.datasource.filteredData?.length || 0);
  }

  toggleRowSelection(row: WorkingSureFlowLoop): void {
    this.selection.toggle(row);
  }

}
